import React from "react";

interface AplicativoProps {
  onOpenModal: () => void;
}

const Aplicativo: React.FC<AplicativoProps> = ({ onOpenModal }) => (
  <section className="border-b border-bone-300 bg-bone">
    <div className="mx-auto max-w-site px-5 py-16 lg:px-8 lg:py-20">
      <div className="panel">
        <div className="panel-head">
          <span className="font-mono text-[0.6875rem] uppercase tracking-[0.16em] text-soil/60">
            Aplicativo
          </span>
          <span className="rounded bg-soy/20 px-2 py-0.5 font-mono text-[0.625rem] uppercase tracking-[0.12em] text-soy-dark">
            em breve nas lojas
          </span>
        </div>

        <div className="grid items-center gap-10 p-6 sm:p-9 lg:grid-cols-[1.15fr_1fr] lg:gap-14">
          <div>
            <h2 className="font-display text-display-sm font-bold text-soil">
              Cabe no bolso, funciona no campo.
            </h2>
            <p className="mt-4 text-base leading-relaxed text-soil/70">
              Estamos finalizando a publicação na App Store e no Google Play.
              Deixe seu contato e avisamos assim que liberar o download.
            </p>

            <div className="mt-7 flex flex-wrap gap-3">
              <button onClick={onOpenModal} className="cta-solid">
                Avise-me no lançamento
              </button>
            </div>

            <ul className="mt-8 grid gap-2.5 sm:grid-cols-2">
              {[
                "Entrada por biometria",
                "Notificação a cada etapa do pedido",
                "Funciona no 4G do campo",
                "Exclusão da conta pelo próprio app",
              ].map((item) => (
                <li key={item} className="flex items-start gap-2.5 text-sm text-soil/70">
                  <svg
                    width="15"
                    height="15"
                    viewBox="0 0 16 16"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="mt-0.5 shrink-0 text-agro-accent"
                    aria-hidden="true"
                  >
                    <path d="M3 8.5l3.5 3.5L13 5" />
                  </svg>
                  {item}
                </li>
              ))}
            </ul>
          </div>

          <div className="flex justify-center lg:justify-end">
            <div className="w-full max-w-[15rem] rounded-[1.75rem] border border-bone-300 bg-white p-2.5 shadow-[0_20px_50px_-28px_rgba(20,32,14,0.4)]">
              <div className="overflow-hidden rounded-[1.35rem] bg-soil">
                <div className="flex items-center justify-between px-4 pb-3 pt-4">
                  <img src="/logo.png" alt="" className="h-6 w-auto" />
                  <span className="num text-[0.625rem] text-white/40">09:41</span>
                </div>
                <div className="space-y-2 px-3 pb-4">
                  <div className="rounded-lg bg-white/95 p-3">
                    <p className="field-label">Fertilizantes</p>
                    <p className="mt-1 text-xs font-bold text-soil">Ureia 45% N</p>
                    <p className="num mt-0.5 text-[0.625rem] text-soil/50">
                      Vale Verde · mín. 5 t
                    </p>
                  </div>
                  <div className="rounded-lg bg-soy p-3">
                    <p className="font-mono text-[0.5625rem] uppercase tracking-[0.12em] text-soil/70">
                      tonelada · CIF
                    </p>
                    <p className="num mt-1 text-sm font-bold text-soil">R$ 3.284,00</p>
                    <p className="mt-0.5 text-[0.625rem] text-soil/70">
                      Adicionar ao carrinho
                    </p>
                  </div>
                  <div className="rounded-lg bg-white/10 p-3">
                    <p className="font-mono text-[0.5625rem] uppercase tracking-[0.12em] text-white/50">
                      pedido #8830
                    </p>
                    <p className="mt-1 text-[0.6875rem] font-semibold text-white">
                      Itens em separação
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default Aplicativo;
